import React from 'react';
import { Box, Typography } from '@mui/material';

const PlaceholderPage = ({ title }) => (
    <Box sx={{ p: 4 }}>
        <Typography variant="h4">{title}</Typography>
        <Typography sx={{ mt: 2 }}>{title} page is coming soon.</Typography>
    </Box>
);

export default PlaceholderPage;
